export default {
  AI_MOCK_INTERVIEW: {
    name: 'AI Mock Interview',
    type: 'AI Mock Interview',
    id: 'AI Mock Interview',
    templateId: 'AI_MOCK_INTERVIEW',
  },
};
